const formatCurrency = (amount) => {
    const format =  parseFloat(amount).toLocaleString('en-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return format;
}

function calculatePriceDetails(domainPrice, domainPriceSin, periodCambiar) {
    let costAgregar, secondPriceAgregar, crossAgregar;
    
    const periodData = domainPrice.precio[periodCambiar - 1];
    const periodDataSin = domainPriceSin.precio[periodCambiar - 1];
  
    if (parseFloat(periodData.costo) === 0 && parseFloat(periodData.preciomostrado) === 0) {
        costAgregar = periodDataSin.preciomostrado;
        secondPriceAgregar = periodData.preciomostrado;
        crossAgregar = true;
    } else if (periodData.tachado) {
        costAgregar = periodData.preciomostrado;
        secondPriceAgregar = periodData.costo;
        crossAgregar = periodData.tachado;
    } else if (periodData.costo && periodData.preciomostrado) {
        costAgregar = periodData.costo;
        secondPriceAgregar = periodData.preciomostrado;
        crossAgregar = false;
    } else {
        costAgregar = periodData.costo;
        secondPriceAgregar = periodData.preciomostrado;
        crossAgregar = true;
    }
  
    const selectPeriods = domainPrice.precio.reduce((acc, period) => {
        const costo = String(period.costo).replaceAll(',', '');
        const preciomostrado = String(period.preciomostrado).replaceAll(',', '');
        const cross = parseFloat(costo) !== parseFloat(preciomostrado);
        acc[period.periodo] = {
            cost: formatCurrency(period.preciomostrado),
            cross_price: cross,
            second_price: formatCurrency(period.costo)
        };
        return acc;
    }, {});
  
    const selectPeriodsWithout = domainPriceSin.precio.reduce((acc, period) => {
        const costo = String(period.costo).replaceAll(',', '');
        const preciomostrado = String(period.preciomostrado).replaceAll(',', '');
        const cross = parseFloat(costo) !== parseFloat(preciomostrado);
        acc[period.periodo] = {
            cost: formatCurrency(period.preciomostrado),
            cross_price: cross,
            second_price: formatCurrency(period.costo)
        };
        return acc;
    }, {});
  
    const newPrice = {
        cost: costAgregar,
        cross_price: crossAgregar,
        second_price: secondPriceAgregar
    };
  
    return { newPrice, selectPeriods, selectPeriodsWithout };
}

export default calculatePriceDetails;
